import { Link } from 'react-router-dom';
import type { FC } from 'react';
import { categories, videos } from '@/mocks/videos';

const HeroSection: FC = () => {
  const heroVideos = videos.filter(v => v.isHot).slice(0, 5);

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20background%20with%20abstract%20geometric%20shapes%20in%20deep%20red%20and%20black%20tones%2C%20modern%20entertainment%20platform%20atmosphere%2C%20smooth%20gradients%2C%20theatrical%20lighting%20effects%2C%20professional%20streaming%20service%20backdrop%2C%20velvet%20curtain%20texture%2C%20dramatic%20shadow%20play&width=1800&height=900&seq=hero-bg-01&orientation=landscape"
          alt="棒棒TV - 免费在线观看高清视频"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/70 via-background-950/50 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 md:px-6 pt-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Left Content */}
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-500/20 border border-primary-500/30 mb-6">
              <i className="ri-fire-line text-primary-400 text-sm"></i>
              <span className="text-sm text-primary-300 whitespace-nowrap">全网最热视频 · 免费在线观看</span>
            </div>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-50 leading-tight mb-4">
              高清视频
              <span className="text-primary-400"> 流畅播放</span>
              <br />
              不卡顿免缓冲
            </h1>

            <p className="text-foreground-300 text-base md:text-lg max-w-xl mx-auto lg:mx-0 mb-8 leading-relaxed">
              棒棒TV汇聚海量电视剧全集、电影大全、最新剧集，提供免费在线观看高清视频服务。
              极速加载、流畅播放，随时随地畅享精彩影视内容。
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <Link
                to="/category/drama"
                className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full transition-all duration-300 cursor-pointer text-center text-sm"
              >
                <i className="ri-play-circle-line mr-2"></i>
                开始观看
              </Link>
              <Link
                to="/category/movie"
                className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 border border-foreground-300/30 hover:border-primary-500/60 text-foreground-100 hover:text-primary-400 font-medium rounded-full transition-all duration-300 cursor-pointer text-center text-sm"
              >
                <i className="ri-film-line mr-2"></i>
                电影大全
              </Link>
            </div>

            {/* Stats */}
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-10">
              <div className="text-center">
                <div className="text-2xl font-heading font-bold text-accent-400">10万+</div>
                <div className="text-xs text-foreground-500 mt-1">视频资源</div>
              </div>
              <div className="w-px h-10 bg-foreground-300/20"></div>
              <div className="text-center">
                <div className="text-2xl font-heading font-bold text-accent-400">5000万+</div>
                <div className="text-xs text-foreground-500 mt-1">累计用户</div>
              </div>
              <div className="w-px h-10 bg-foreground-300/20"></div>
              <div className="text-center">
                <div className="text-2xl font-heading font-bold text-accent-400">4K</div>
                <div className="text-xs text-foreground-500 mt-1">高清画质</div>
              </div>
            </div>
          </div>

          {/* Right Featured Cards */}
          <div className="flex-1 w-full max-w-lg">
            <div className="grid grid-cols-2 gap-3">
              {heroVideos.map((video, index) => (
                <Link
                  key={video.id}
                  to={`/article/${video.id}`}
                  className="group relative overflow-hidden rounded-lg cursor-pointer"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="aspect-[3/4] overflow-hidden">
                    <img
                      src={video.cover}
                      alt={video.title}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                    />
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-transparent to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-3">
                    <p className="text-xs font-medium text-foreground-50 line-clamp-1">{video.title}</p>
                    <p className="text-xs text-accent-400 mt-0.5">{video.rating}</p>
                  </div>
                  {index === 0 && (
                    <div className="absolute top-2 left-2 px-2 py-0.5 text-xs font-bold rounded bg-primary-500 text-background-50 whitespace-nowrap">
                      今日推荐
                    </div>
                  )}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Gradient Fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-background-50 to-transparent pointer-events-none"></div>
    </section>
  );
};

export default HeroSection;